// extracted by mini-css-extract-plugin
export default {"productGrid":"s0-z","centerLink":"t0-z","productSection":"u0-z","item":"v0-z","ctaButton":"w0-z"};